export default __webpack_public_path__ + "static/media/ac_ead.423a090f.bmp";